import http, { noneTokenHttp } from "../../utils/http";
import { toast } from "../../utils/toast";

// 컨설팅 목록 (상담신청, 무료체험)
export const getConsultings = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/consultings/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const consultingsExcelDownload = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/consultings/excel/download`, params, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 컨설팅 등록 (상담신청, 무료체험)
export const postConsultings = (params) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post(`/consultings`, params)
      .then((res) => {
        toast.success(`${params.name}님의 상담이 등록 되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 컨설팅 수정 (상담신청, 무료체험)
export const putConsultings = (consultingIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/consultings/${consultingIdx}`, params)
      .then((res) => {
        toast.success(`${params.name}님의 상담이 수정 되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 무료체험 중감점검 메일 발송
export const sendConsultinsEmailMidCheck = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post('/consultings/emails/midcheck', params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 무료체험 중감점검 메일 발송
export const sendConsultinsEmailEnd = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post('/consultings/emails/end', params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};